import type { Attachment } from 'svelte/attachments'

export const DEFAULT_GUTTER = 16

/**
 * Shifts an absolutely positioned element back into the viewport when its preferred
 * placement would push it past either edge. The left edge wins if it fits neither.
 */
export function clampToViewport(gutter = DEFAULT_GUTTER): Attachment<HTMLElement> {
  return (node) => {
    function update(): void {
      node.style.translate = ''

      const { left, right } = node.getBoundingClientRect()
      const available = document.documentElement.clientWidth
      const shift = Math.max(gutter - left, Math.min(0, available - gutter - right))

      node.style.translate = shift === 0 ? '' : `${shift}px`
    }

    update()
    window.addEventListener('resize', update)

    return () => {
      window.removeEventListener('resize', update)
    }
  }
}
